import Link from '../link/type/Link';
import jsonFetch from './json-fetch';
import jsonRequest from './json-request';
import apiUrl from './api-url';
import headers from './headers';

type T = (id: string) => Promise<Link>;

const f: T = async (id) => {
    return jsonFetch(
        `${apiUrl()}/share-links/get-link-by-id/${id}`,
        jsonRequest({
            method: 'GET',
            headers: headers(),
        })
    );
};

export default f;
